import Button from 'material-ui/Button';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { CSSProperties } from 'react';
import { RouteComponentProps } from 'react-router';
import { DASHBOARD_NEED_HELP_BUTTON_TEXT } from '../../assets/ApplicationCopy';
import '../../assets/styles/Dashboard.css';
import * as Style from '../../assets/styles/Pages/Home';
import { CONSTANTS } from '../../assets/UIConstants';
import { ApplicationStore } from '../../data_layer/stores/ApplicationStore';
import { BasalMetabolicRate } from '../components/dashboardPanels/BasalMetabolicRate';
import { BodyFat } from '../components/dashboardPanels/BodyFat';
import { SkeletalMuscleMass } from '../components/dashboardPanels/FatFreeMass';
import { SegmentalLeanAnalysis } from '../components/dashboardPanels/SegmentalLeanAnalysis';
import { TotalBodyWater } from '../components/dashboardPanels/TotalBodyWater';
import { VisceralFatLevel } from '../components/dashboardPanels/VisceralFatLevel';
import { NeedHelpDialog } from '../components/NeedHelpDialog';
import { Page } from './Page';

interface IRouteParams {
    id?: string; // numeric string
}

export interface DashboardProps extends RouteComponentProps<IRouteParams> {
    store: ApplicationStore;
}

interface State {
    helpModalOpen: boolean;
}

@inject('store')
@observer
export class Dashboard extends Page<DashboardProps, State> {
    private scanId?: number;
    public constructor(props: DashboardProps) {
        super(props);
        this.state = {
            helpModalOpen: false,
        };
        if (this.props.match.params.id) {
            this.scanId = parseInt(this.props.match.params.id);
        }
        this.setActivePoint();
    }

    public componentWillReceiveProps(nextProps: DashboardProps): void {
        if (nextProps.match.params.id) {
            this.scanId = parseInt(nextProps.match.params.id);
        } else {
            this.scanId = undefined;
        }
        this.setActivePoint();
    }

    private setActivePoint(): void {
        if (undefined != this.scanId) {
            this.props.store.scanStore.setActiveScan(this.scanId);
        } else {
            this.props.store.scanStore.clearActiveScan();
        }
    }

    private openHelpModal(): void {
        this.setState({ helpModalOpen: true });
    }

    private closeHelpModal(): void {
        this.setState({ helpModalOpen: false });
    }

    public renderPage(): React.ReactNode {
        if (this.props.store.scanStore.storeIsReady === false) {
            return null;
        }

        return (
            <div style={Style.Home}>
                <div style={Style.PanelContainer}>
                    <SkeletalMuscleMass scanStore={this.props.store.scanStore} scan_id={this.scanId} />
                    <BodyFat scanStore={this.props.store.scanStore} scan_id={this.scanId} />
                    <TotalBodyWater scanStore={this.props.store.scanStore} scan_id={this.scanId} />
                    <VisceralFatLevel scanStore={this.props.store.scanStore} scan_id={this.scanId} />
                    <BasalMetabolicRate scanStore={this.props.store.scanStore} scan_id={this.scanId} />
                    <SegmentalLeanAnalysis scanStore={this.props.store.scanStore} />
                </div>

                <div style={footerRow}>
                    <Button
                        onClick={() => {
                            this.openHelpModal();
                        }}
                        style={needHelpButtonStyle}
                    >
                        {DASHBOARD_NEED_HELP_BUTTON_TEXT}
                        <div style={questionMark}>?</div>
                    </Button>
                    <NeedHelpDialog
                        store={this.props.store}
                        open={this.state.helpModalOpen}
                        close={() => this.closeHelpModal()}
                        onError={(message: string) => this.showError(message)}
                    />
                </div>
            </div>
        );
    }
}

const footerRow: CSSProperties = {
    position: 'fixed',
    bottom: 40,
    left: 40,
};

const needHelpButtonStyle: CSSProperties = {
    borderRadius: 60 + 'px',
    lineHeight: 40 + 'px',
    paddingRight: 10 + 'px',
    paddingLeft: 60 + 'px',
    fontSize: 18 + 'px',
    fontWeight: 'bold',
    color: CONSTANTS.COLORS.BUTTON_TEXT_GREY,
    backgroundColor: CONSTANTS.COLORS.BUTTON_BACKGROUND_GREY,
    boxShadow: CONSTANTS.BOX_SHADOW.NEED_HELP_BUTTON,
};

const questionMark: CSSProperties = {
    backgroundColor: CONSTANTS.COLORS.TEXT_INPUT_BORDER,
    color: 'white',
    fontWeight: 'bold',
    fontSize: 25 + 'px',
    lineHeight: 60 + 'px',
    borderRadius: 60 + 'px',
    height: 60 + 'px',
    width: 60 + 'px',
    marginLeft: 40 + 'px',
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/pages/Dashboard.tsx